import React, {useState} from 'react';
import PropTypes from 'prop-types'
import { Box, Card, CardContent, List, ListItem } from '@mui/material';
import { AppBadge, AppPage, AppTextStyle, AppToast } from '@shared';
import axiosRails from '@utils/axios-rails';
import {statusVariations } from 'utils';
import OrderItemAddress from "./components/components/OrderItemAddress";
import ResourceLogList from "./components/ResourceLogList";
import EvidenceList from "components/shared/EvidenceList";

const propTypes = {
  order: PropTypes.object.isRequired,
}

// A bulleted list with the spacing these rows have always had: a gap after each
// bold label, and an inline-flex status row.
const listSx = {
  listStyleType: 'disc',
  pl: 3,
  '& > li': { display: 'list-item', px: 0, py: 0.25 },
  '& > li > span': { mr: '5px' },
};

const OrderShow = (props) => {

  const order = props.order;
  const addressFields = ["name", "address", "national_id", "phone", "province"];
  
  const [status, setStatus] = useState(order.status);
  const [toast, setToast] = useState("");

  const dismissToast = () => setToast("");

  const unassign = async () => {
    if (confirm("Esta acción es irreversible, continuar?")) {
      try {
        const response = await axiosRails.post(order.unassign_url); 
        const { data } = response;

        if (data.errors) { 
          setToast(data.message);
          return null;
        }

        if (data.success){
          setStatus('unassigned');
          setToast(I18n.t("messages.update_successful"));
        } 
      } catch (error) {
        console.warn(error);
        setToast(I18n.t("messages.request_error"));
      }
    }
  }

  let primaryAction = status == "assigned" ? {
    content: 'Desasignar',
    onAction: unassign,
    destructive: true
  } :  null;

  return (
      <AppPage
          breadcrumbs={[{content: 'Atras', url: '/orders'}]}
          title={`Detalle Orden `}
          subtitle={ I18n.t(`enum.status.${status}`) }
          primaryAction={primaryAction}
      >
        <Card>
          <CardContent>
            <List sx={listSx}>
              <InfoLine title={"ID Orden"} text={ order.delivery_detail_provider_order_id } />
              <InfoLine title={I18n.t("activerecord.attributes.order.order_number")} text={ order.order_number } /> 

              { !!order.courier_name &&
                <>
                  <InfoLine title={I18n.t("activerecord.attributes.order.courier_name")} text={ order.courier_name } /> 
                  <InfoLine title={I18n.t("activerecord.models.team.one")} text={ order.team_name } /> 
                </>
              }

              {(!!order.provider_data?.shipping_address) &&
                addressFields.map((field) => (
                  <ListItem key={field}>
                    <AppTextStyle variation={"strong"}>
                      { I18n.t(`shopify.order.shipping_address.${field}`) }:
                    </AppTextStyle>
                    {order.provider_data.shipping_address[field]}
                  </ListItem>
                ))
              }

              <ListItem sx={{ '& span': { display: 'inline-flex' }, '& div.ml4': { display: 'flex' } }}>
                <AppTextStyle variation={"strong"}>
                  {I18n.t("activerecord.attributes.order.status")}:
                </AppTextStyle>
                <AppTextStyle variation={ statusVariations[status] }>
                  { I18n.t(`enum.status.${status}`) }
                  <OrderItemAddress providerData={ order.provider_data } />
                </AppTextStyle>
              </ListItem>

              { order.recipient_name && <InfoLine title={I18n.t("activerecord.attributes.order.recipient_name")} text={ order.recipient_name } /> }
              { order.delivered_at_human && <InfoLine title={I18n.t("activerecord.attributes.order.delivered_at")} text={ order.delivered_at_human } /> }

              <ListItem>
                <AppTextStyle variation={"strong"}>
                  {I18n.t("activerecord.attributes.order.provider_name")}:
                </AppTextStyle>
                <Box component="span" sx={{ ml: 0.5 }}>
                  <AppBadge status="success">{I18n.t("enum.provider_name."+order.provider_name)}</AppBadge>
                </Box>
              </ListItem>
            </List>
          </CardContent>
        </Card>

        <ResourceLogList title="Historial de Entrega" logs={ order.order_logs } />
        <EvidenceList evidences={ order.evidences } />
        { toast && <AppToast content={toast} onDismiss={ dismissToast } /> }

      </AppPage>
  )
}

const InfoLine = ({ title, text }) => (
  <ListItem>
    <AppTextStyle variation={"strong"}>
      { title }:
    </AppTextStyle>
    { text }
  </ListItem>
)

OrderShow.propTypes = propTypes;

export default  OrderShow;
